/**
 * Editor Layer Configuration
 * Data-driven layer definitions for the tile editor
 */

import { LayerType } from '../../shared/TileEditorTypes';

export interface EditorLayerConfig {
  id: string;
  name: LayerType;
  displayName: string;
  visible: boolean;
  locked: boolean;
  opacity: number;
  order: number; // For layer panel ordering
  description?: string;
}

export const EDITOR_LAYERS: EditorLayerConfig[] = [
  {
    id: 'ground',
    name: LayerType.GROUND,
    displayName: 'Ground',
    visible: true,
    locked: false,
    opacity: 1.0,
    order: 0,
    description: 'Base terrain and floor tiles'
  },
  {
    id: 'collision',
    name: LayerType.COLLISION,
    displayName: 'Collision',
    visible: true,
    locked: false,
    opacity: 1.0,
    order: 1,
    description: 'Invisible collision boundaries'
  },
  {
    id: 'objects',
    name: LayerType.OBJECTS,
    displayName: 'Objects',
    visible: true,
    locked: false,
    opacity: 1.0,
    order: 2,
    description: 'Decorative objects and props'
  },
  {
    id: 'entities',
    name: LayerType.ENTITIES,
    displayName: 'Entities',
    visible: true,
    locked: false,
    opacity: 1.0,
    order: 3,
    description: 'NPCs, mobs, and interactive entities'
  },
  {
    id: 'triggers',
    name: LayerType.TRIGGERS,
    displayName: 'Triggers',
    visible: true,
    locked: false,
    opacity: 1.0,
    order: 4,
    description: 'Event triggers and teleporters'
  }
];

/** Get layer by type */
export const getLayerConfig = (type: LayerType): EditorLayerConfig | undefined => {
  return EDITOR_LAYERS.find(l => l.name === type);
};

/** Get default layer state for editor */
export const getDefaultEditorLayers = () => {
  return EDITOR_LAYERS.map(l => ({
    id: l.id,
    name: l.name,
    visible: l.visible,
    locked: l.locked,
    opacity: l.opacity
  }));
};
